import { RichText, RichTextBlock } from 'prismic-reactjs';
import styled from 'styled-components';

const P = styled.p`
  display: block;
  text-align: center;
  font-style: italic;
  font-size: 14px;
  color: rgb(148, 148, 148);
`;

const Caption = ({ caption }: { caption: RichTextBlock[] | string }) => {
  if (typeof caption === 'string') {
    return (
      <P>
        {caption}
      </P>
    );
  }

  if (RichText.asText(caption) !== '') {
    return (
      <P>
        <span className="image-label">{RichText.asText(caption)}</span>
      </P>
    );
  }

  return null;
};

export default Caption;
